import api from './api';

const BASE = '/api/v1/pos';

const posAPI = {
  // Products
  listProducts: (params = {}) => api.get(`${BASE}/products`, { params }),
  getProductBySku: (sku) => api.get(`${BASE}/products/by-sku/${encodeURIComponent(sku)}`),
  createProduct: (data) => api.post(`${BASE}/products`, data),
  updateProduct: (id, data) => api.put(`${BASE}/products/${id}`, data),
  deleteProduct: (id) => api.delete(`${BASE}/products/${id}`),

  // Orders
  listOrders: (params = {}) => api.get(`${BASE}/orders`, { params }),
  createOrder: (data) => api.post(`${BASE}/orders`, data),
  getOrder: (id) => api.get(`${BASE}/orders/${id}`),
  updateOrderStatus: (id, payment_status) =>
    api.patch(`${BASE}/orders/${id}/status`, { payment_status }),
  deleteOrder: (id) => api.delete(`${BASE}/orders/${id}`),
};

export default posAPI;
